export async function apiRetry(fn, retries = 3, delayMs = 800) {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const result = await fn();
      return result;
    } catch (err) {
      // SyntaxError with "is not valid JSON" means the server returned HTML (e.g. nginx 503 page)
      const isHtmlResponse = err instanceof SyntaxError &&
        String(err?.message || "").includes("is not valid JSON");
      const is503 = err?.status === 503 || err?.status === 504 ||
        err?.code === 503 || err?.code === 504 ||
        isHtmlResponse ||
        (typeof err === "object" && /50[34]/.test(String(err?.message || "")));
      if (attempt === retries || !is503) throw err;
      await new Promise(r => setTimeout(r, delayMs * (attempt + 1)));
    }
  }
}
